export var TabEventType;
(function (TabEventType) {
    TabEventType["Click"] = "click";
    TabEventType["First"] = "first";
    TabEventType["Last"] = "last";
    TabEventType["Next"] = "next";
    TabEventType["Prev"] = "prev";
})(TabEventType || (TabEventType = {}));
